import { Spinner } from '@consigli/facade';
import { useGetBeamstarSessionQuery } from '@consigli/hooks';
import { Sheet, SheetContent, SheetDescription, SheetHeader, SheetTitle } from '@consigli/shadcn';

import { LoadError } from '../load-error';
import { TurnCard } from './turn-card';

interface SessionReaderProps {
  conversationId: string;
  targetTurnId?: string;
  onClose: () => void;
}

export const SessionReader = ({ conversationId, targetTurnId, onClose }: SessionReaderProps) => {
  const { data: session, error } = useGetBeamstarSessionQuery({ conversationId });

  return (
    <Sheet open onOpenChange={(open) => !open && onClose()}>
      <SheetContent
        side="right"
        className="flex w-full flex-col !gap-0 overflow-hidden sm:max-w-3xl"
      >
        <SheetHeader className="shrink-0 border-b px-6 pt-6 pb-4">
          <SheetTitle className="text-lg font-semibold">Session</SheetTitle>
          <SheetDescription>
            {session &&
              [session.projectId ?? 'No project', session.buildingId ?? 'No building'].join(' · ')}
          </SheetDescription>
        </SheetHeader>
        <div className="flex-1 overflow-y-auto px-6 py-4">
          {error ? (
            <LoadError title="Could not load the session" error={error} />
          ) : session ? (
            <ol className="flex flex-col gap-4">
              {session.turns.map((turn, index) => (
                <TurnCard
                  key={turn.id}
                  turn={turn}
                  number={index + 1}
                  isTarget={turn.id === targetTurnId}
                />
              ))}
            </ol>
          ) : (
            <div className="flex justify-center py-12">
              <Spinner />
            </div>
          )}
        </div>
      </SheetContent>
    </Sheet>
  );
};
